import React, { Fragment } from "react";

import {
  PDFViewer,
  PDFDownloadLink,
  Document,
  Page,
  Text,
  View,
  Image,
} from "@react-pdf/renderer";

import styles from "./styles";

import CONFIG from "../../../config";

const productsLabel = (props) => {
  return (
    <View style={[styles.container, styles.itemsWrapper]}>
      <View style={styles.qtyContainer}>
        <Text>Qty</Text>
      </View>
      <View style={styles.otherContainer}>
        <Text>Card Value</Text>
      </View>
      <View style={styles.itemContainer}>
        <Text>Item</Text>
      </View>
      <View style={[styles.totalContainer, styles.alignRightContainer]}>
        <Text>Total</Text>
      </View>
    </View>
  );
};

export default productsLabel;
